import React from 'react'
import { Link } from 'react-router-dom'
import PrintCard from '../PrintCard/PrintCard'
import './printView.css'

import freeDelevery from '../../assets/icons/free-delivery.png'
import arrow from '../../assets/icons/arrow-right-s-line.svg'
import crop from '../../assets/icons/crop.svg'

import facebook from '../../assets/icons/facebook.png'
import pinterest from '../../assets/icons/pinterest.png'
import x from '../../assets/icons/x.png'

import card1 from '../../assets/images/tigerOntree.jpg'
import card2 from '../../assets/images/tigerPrint.jpg'
import card3 from '../../assets/images/roar.jpg'
import card4 from '../../assets/images/prince.jpg'
import card5 from '../../assets/images/kuruttu.jpg'
import card6 from '../../assets/images/neluma.webp'

import Helmet from './../Helmet/Helmet';


const cardData = [
    { imgSrc: card3, to: "/product/tell-the-wild-im-home", link: "Add to cart Tell the wild. I’m home" },
    { imgSrc: card4, to: "/product/hunt-goals-not-set", link: "I don’t set goals. I hunt them down" },
    { imgSrc: card5, to: "/product/brave-fearless-bold-strong", link: "I am Brave, Fearless, Bold & Strong" },
    { imgSrc: card6, to: "/product/neluma", link: "Neluma" },
    { imgSrc: card2, to: "/product/the-perfect-amount-of-sunkissed", link: "The perfect amount of Sunkissed" },
    { imgSrc: card1, to: "/product/perfect-view-comfort-rating", link: "Add to cart The view is a 10/10. The comfort is 1000/10" }
];

// Shuffle array function
const shuffleArray = (array) => {
    let currentIndex = array.length, temporaryValue, randomIndex;
  
    while (0 !== currentIndex) {
  
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
  
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
  
    return array;
  }

  const shuffledCards = shuffleArray([...cardData]).slice(0, 3);


const PrintView = ({heading, content, printImage, title}) => {

    const shareOnFacebook = () => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`, '_blank');
    };
    
    const shareOnPinterest = () => {
        window.open(`https://www.pinterest.com/pin/create/button/?url=${window.location.href}&media=${printImage}`, '_blank');
    };
    
    const shareOnX = () => {
        window.open('https://www.x.com/share?url=' + encodeURIComponent(window.location.href), '_blank');
    };

    const handleOrderNowClick = () => {
        const phoneNumber = '94753680946';
        const message = `I would like to order the print: ${heading}.\n\nProduct URL: https://ravisarajayamanna.vercel.app/${printImage}`;
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    };

  return <Helmet title={title}>
  <section className='__black'>
        <div className="w-1 fsb print__view-top">
            <div className="blog__socialmedia-bar">
                <span>share:</span>
                <button onClick={shareOnFacebook}><img src={facebook} alt="facebook" /></button>
                <button onClick={shareOnPinterest}><img src={pinterest} alt="pinterest" /></button>
                <button onClick={shareOnX}><img src={x} alt="x" /></button>
            </div>
            <div>
                <Link to='/'>Home <img className='arrow_link' src={arrow} alt="" /></Link>
                <Link to='/prints'>Prints <img className='arrow_link' src={arrow} alt="" /></Link>
                <span>{heading}</span>
            </div>
            <div>
                <Link to='/prints'><img className='arrow_link-left' src={arrow} alt="" />Back</Link>
            </div>
        </div>
        <div className="w-1 fsb print__view-container">
            <div className='print__view-img'>
                <img className='printImage' src={printImage} alt="" />
            </div>
            <div className='print__view-details'>
                <Link className='print__view-printlink' to='/prints'>Prints</Link>
                <h1>{heading}</h1>
                <div className='fsba order__instock'>
                    <button className='print__view-orderNow' onClick={handleOrderNowClick}>Order Now</button>
                    <span className='instock'>In stock</span>
                </div>
                <p>{content}</p>
                <div className='fsb print__view-order'>
                    <div className='print__view-icons__section'>
                        <img className='print__view-icons' src={freeDelevery} alt="free delevery" />
                        <span>Free<br />Delivery</span>
                    </div>
                    <div className='print__view-icons__section'>
                        <img className='print__view-icons' src={crop} alt="Frame" />
                        <span>Sizes <br />8⨯12, 16⨯24</span>
                    </div>
                </div>
            </div>
        </div>
        <div className="w-1">
            <div className="print__view-related">
                <h2>Related Products</h2>
            </div>
            <div className='fsb print__view-related-cards'>
                {shuffledCards.map((card, index) => (
                    <PrintCard
                    to={card.to}
                    key={index}
                    imgSrc={card.imgSrc}
                    link={card.link}
                    style={{ width: '32%' }}
                    // imgStyle={{ height: '500px' }}
                    />
                ))}
            </div>
        </div>
  </section>
  </Helmet>
}

export default PrintView